const doc = [({"ko":({"adminConstantPayType":({"all":"모든 결제 수단으로 가능", "onSite":"현지 결제", "prePayment":"신용 카드 결제"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;